import { AxiosRequestConfig } from "axios";

import { ApiError, AudienceBuild, Site, SiteCatchment } from "@/types";
import { fetchData } from "@/utils";

type GetSitesApiResponse = {
  data: Site[];
  error: ApiError | null;
};

export const getSites = async (
  accessToken: string,
  client: string
): Promise<GetSitesApiResponse> => {
  let url = `${process.env.REACT_APP_API_URL}/v2/site/list?client=${client}`;

  const config: AxiosRequestConfig = {
    method: "GET",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  return fetchData(config);
};

type GetCatchmentApiResponse = {
  data: SiteCatchment[];
  error: ApiError | null;
};

export const getCatchment = async (
  accessToken: string,
  sites: number[],
  client: string
): Promise<GetCatchmentApiResponse> => {

  const sitesParam = sites.join(',')

  let url = `${process.env.REACT_APP_API_URL}/v2/site/catchment?sites=${sitesParam}&client=${client}`;

  const config: AxiosRequestConfig = {
    method: "GET",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };

  return fetchData(config);
};


type GetSizetApiResponse = {
  data: AudienceBuild ;
  error: ApiError | null;
};

export const getCatchmentSize = async (
  accessToken: string,
  catchment: string[],
  audienceId?: string,
): Promise<GetSizetApiResponse> => {

  let url = `${process.env.REACT_APP_API_URL}/v2/site/catchment/size`;
  audienceId && (url += `?audience_id=${audienceId}`)

  const config: AxiosRequestConfig = {
    method: "POST",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    data: { sectors: catchment }
  };

  return fetchData(config);
};
